import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from './ui/input';

/**
 * Password input with an eye icon on the right that toggles visibility.
 *
 * Accepts every prop a normal <Input> accepts. The toggle button is keyboard
 * accessible via tab and announces the current state via aria-label.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = '', testIdToggle, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={`pr-11 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        data-testid={testIdToggle}
        tabIndex={0}
        className="absolute inset-y-0 right-0 flex items-center justify-center w-11 text-[#1a1a1a]/45 hover:text-[#0a5c44] focus:outline-none focus-visible:text-[#0a5c44] transition-colors"
      >
        <Icon className="w-4 h-4" />
      </button>
    </div>
  );
});

export default PasswordInput;
